import { AddRounded } from "@mui/icons-material";
import { Paper } from "@mui/material";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Button, InputDate } from "../../../controls";
import { Link } from "react-router-dom";

const options = {
  colors: ["var(--primary-color)", "#00e1ff"],
  chart: {
    type: "bar",
    height: 350,
    stacked: true,
    toolbar: {
      show: true,
    },
    zoom: {
      enabled: true,
    },
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        legend: {
          position: "bottom",
          offsetX: -10,
          offsetY: 0,
        },
      },
    },
  ],
  plotOptions: {
    bar: {
      borderRadius: 0,
      horizontal: false,
      columnWidth: "55%",
      endingShape: "rounded",
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
  },

  noData: {
    text: "Loading...",
  },
  xaxis: {
    categories: moment.monthsShort(),
    legend: {
      position: "right",
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
  },
  grid: {
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  yaxis: {
    labels: {
      formatter: (val) => "$" + val.toLocaleString(),
      style: {
        fontSize: "14px",
      },
    },
  },
};

const InvoiceVsPaidChart = (props) => {
  const { invs } = props;
  const [date, setDate] = useState(new Date());
  const [series, setSeries] = useState([]);

  const handleInpChange = (newVal) => {
    setDate(newVal);
  };

  useEffect(() => {
    if (date) {
      var fullYear = date && new Date(date).getFullYear();
      var dateLi = [
        `01/${fullYear}`,
        `02/${fullYear}`,
        `03/${fullYear}`,
        `04/${fullYear}`,
        `05/${fullYear}`,
        `06/${fullYear}`,
        `07/${fullYear}`,
        `08/${fullYear}`,
        `09/${fullYear}`,
        `10/${fullYear}`,
        `11/${fullYear}`,
        `12/${fullYear}`,
      ];

      var invAmt = [];
      var paidInv = [];
      dateLi.forEach((date) => {
        var invPayments = invs
          .filter(
            (j) => moment(j.dueDate, "MM/DD/YYYY").format("MM/YYYY") === date
          )
          .map((j) => j.invPayments)
          .flat();

        invAmt.push(
          invPayments
            .map(
              (j) =>
                j.amount +
                j.invLateFees.map((j) => j.amount).reduce((a, b) => a + b, 0)
            )
            .reduce((a, b) => a + b, 0)
        );
        paidInv.push(
          invPayments
            .map(
              (j) =>
                j.paidAmt +
                j.invLateFees.map((j) => j.paidAmt).reduce((a, b) => a + b, 0)
            )
            .reduce((a, b) => a + b, 0)
        );
      });
      setSeries([
        { name: "Paid", data: paidInv },
        { name: "Invoice", data: invAmt },
      ]);
    }

    return () => {
      setSeries([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, invs]);

  return (
    <Paper>
      <div className="p-10 d-flex flex-wrap g-10 j-between">
        <Link to="/my_account/invoices/invoice_form/">
          <Button variant="outlined" startIcon={<AddRounded />}>
            Create an Invoice
          </Button>
        </Link>

        <div>
          <InputDate
            variant="outlined"
            sx={{ maxWidth: "100px" }}
            size="small"
            value={date}
            openTo="year"
            views={["year"]}
            onChange={handleInpChange}
          />
        </div>
      </div>

      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        width="100%"
        height="300"
      />
    </Paper>
  );
};

export default InvoiceVsPaidChart;
